import { defineComponent as i, computed as o, openBlock as r, createElementBlock as n, normalizeStyle as l } from "vue";
import { _ as s } from "../../../_plugin-vue_export-helper-dad06003.js";
const a = i({
  name: "VSkeleton",
  props: {
    width: {
      type: String,
      required: !0
    },
    height: {
      type: String,
      default: "var(--hobi-font-size-body-m)"
    },
    isCircle: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return { style: o(() => ({
      maxWidth: e.width,
      height: e.isCircle ? e.width : e.height,
      borderRadius: e.isCircle ? "50%" : "var(--hobi-border-radius)"
    })) };
  }
});
function d(e, t, c, h, u, f) {
  return r(), n("div", {
    class: "hobi-skeleton",
    style: l(e.style)
  }, null, 4);
}
const y = /* @__PURE__ */ s(a, [["render", d]]);
export {
  y as default
};
